<template>
  <v-card
    class="d-flex align-center list-item"
    outlined
    :hover="!mission.verified"
    :disabled="isKid && (isMissionVerified || isMissionExpired)"
    :to="
      mission.verified
        ? undefined
        : {
            name: 'MissionDetail',
            params: { id: kidId, missionId: mission.id },
          }
    "
  >
    <v-card-text class="px-6 py-0">
      <v-row>
        <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-start">
          <v-row>
            <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start py-0">
              <v-row>
                <v-col cols="12" md="auto" sm="12" class="d-flex align-center justify-center justify-md-start pr-2">
                  <div class="body-heading-small">{{ mission.name }}</div>
                </v-col>
                <v-col cols="12" md="auto" sm="12" class="d-flex align-center justify-center justify-md-start px-2">
                  <v-icon size="17" color="secondary" class="mr-1">fas fa-gem</v-icon>
                  <span class="body-heading-small">{{ mission.points }}</span>
                </v-col>
                <v-col cols="12" md="auto" sm="12" class="d-flex align-center justify-center justify-md-start px-2">
                  <v-chip v-if="isMissionExpired && !isMissionVerified" color="red" label outlined small>
                    Expired
                  </v-chip>
                  <v-chip v-if="isMissionVerified" color="gray" label outlined small>
                    Completed
                  </v-chip>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-start py-0 text-capitalize" :class="{ 'red--text': isMissionExpired && !isMissionVerified }">
              <v-row no-gutters>
                <v-col cols="12" md="auto" class="text-center text-md-left">
                  <div>deadline:{{ mission.due_date }}</div>
                </v-col>
                <v-col cols="12" md="auto" class="text-center text-md-left">
                  <div v-if="mission.reoccur_scale">({{ missionRecurringFrequencyMap[mission.reoccur_scale] }} recurring)</div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" class="d-flex align-center justify-center justify-md-end">
          <MissionActions :mission="mission" />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import MissionActions from "./MissionActions";

  export default {
    name: "MissionListItem",

    data() {
      return {};
    },

    props: {
      mission: {
        type: Object,
        required: true,
      },
    },

    components: { MissionActions },

    computed: {
      kidId() {
        if (this.$store.getters.userInfo.role === "parent") {
          return this.$route.params.id;
        } else {
          return this.$store.getters.userInfo.id;
        }
      },
      isParent() {
        return this.$store.getters.userInfo.role === "parent";
      },

      isKid() {
        return this.$store.getters.userInfo.role === "child";
      },

      missionRecurringFrequencyMap() {
        return { days: "daily", weeks: "weekly", months: "monthly" };
      },

      isMissionExpired() {
        if (this.mission.due_date) {
          return this.$moment().format("YYYY-MM-DD") > this.$moment(this.mission.due_date).format("YYYY-MM-DD");
        } else {
          return false;
        }
      },

      isMissionVerified() {
        return this.mission.verified;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/MissionListItem.vue